import { render, staticRenderFns } from "./LocaleSwitcher.vue?vue&type=template&id=463b3336"
import script from "./LocaleSwitcher.vue?vue&type=script&lang=ts"
export * from "./LocaleSwitcher.vue?vue&type=script&lang=ts"
import style0 from "./LocaleSwitcher.vue?vue&type=style&index=0&id=463b3336&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports